import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import RegistrationBenefits from './components/RegistrationBenefits';

const UserRegistration = () => {
  const [showVerificationMessage, setShowVerificationMessage] = useState(false);

  return (
    <>
      <Helmet>
        <title>Create Account - OfferSense | Real Estate Agent Registration</title>
        <meta name="description" content="Join OfferSense and streamline your real estate offer management. Create professional comparison reports, leverage AI insights, and deliver exceptional service to your clients." />
      </Helmet>

      <Header />

      <div className="main-content min-h-screen bg-background">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
          <RegistrationHeader />

          <div className={`grid grid-cols-1 ${!showVerificationMessage ? 'lg:grid-cols-2' : ''} gap-8 lg:gap-12 items-start`}>
            {!showVerificationMessage && (
              <div className="order-2 lg:order-1">
                <RegistrationBenefits />
              </div>
            )}

            <div className={`order-1 lg:order-2 ${showVerificationMessage ? 'mx-auto w-full max-w-2xl' : ''}`}>
              <div className="bg-card rounded-xl shadow-elevation-lg p-6 md:p-8 lg:p-10">
                <RegistrationForm onVerificationShow={setShowVerificationMessage} />
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-muted rounded-lg">
              <span className="text-sm text-muted-foreground">
                Questions? Contact us at{' '}
                <a href="mailto:support@offercompare.com" className="text-primary hover:underline font-medium">
                  support@offercompare.com
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserRegistration;